export enum CurrencyTypesEnum {
  US = 'US',
  EU = 'EU',
  BR = 'BR',
}

export const CurrencyIdToString = {
  '1': 'BR',
  '2': 'US',
  '3': 'EU',
};

export enum CurrencyFormattedTypesEnum {
  US = 'USD',
  EU = 'EUR',
  BR = 'BRL',
}

export enum CurrencyIDTypesEnum {
  US = 2,
  EU = 3,
  BR = 1,
}
